import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';

import { ProductClientService, PrClientData, PrClientId } from '../../services/product-client.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { EmployeeService } from '../../services/employee.service';
import { ProductVntaService } from '../../services/product-vnta.service';
import { QuotService } from '../../services/quot.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { QuotationFunctionData } from '../../quotation-activity-functions';
import { ActivityService } from '../../services/activity.service';
import { ActivityClassificationService } from '../../services/activity-classification.service';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { UnitService } from '../../services/unit.service';
import { SuajeService } from '../../services/suaje.service';
import { PermissionService, SpecialPermissions } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Utils } from '../../util';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { ProductionOrderData } from '../../services/production-order.service';

@Component({
  selector: 'app-update-pr-client',
  templateUrl: './update-pr-client.component.html',
  styleUrls: ['./update-pr-client.component.css']
})
export class UpdatePrClientComponent implements OnInit, OnDestroy {
  permission: any = {};

  prClient;

  selectedIds: string[] = [];

  prClientForm: FormGroup;
  selects: any ={};
  sectionForm: FormGroup;
  activityForm: FormGroup;

  sections: any[] = [];
  imagesToDelete = [];
  currentSectionTab: number;
  currentSectionShowing: boolean;
  sectionAppliesPrVnta: boolean = false;
  modalActionsSection = new EventEmitter<string|MaterializeAction>();
  modalParamsSection = [{dismissible: true}];

  generalActivities: any[] = [];
  nonGeneralActivities: any[] = [];
  currentActivityEdit: number;
	unique: any = {
		papel: {prCmpaId: '', prCmpaDescription: '', hilo: this.odpData.hiloOptions[0]},
    suaje: {suajeDescription: ''},
    pegado: {pasteType: '6'}
	};
  uniqueInit = {
    papel: undefined,
    papelData: {},
    suaje: undefined, unfilteredSuajes: []
  }
  get papelPrices() { let name = this.unique.papel.prCmpaDescription; return this.uniqueInit.papelData[name] && this.uniqueInit.papelData[name].prices || [] }
  activityIsGeneral: boolean;
  activityFunction: any;
  activityDataCalc: string;
  activityRanges: any[];
  labels: string[];
  modalActionsActivity = new EventEmitter<string|MaterializeAction>();
  modalParamsActivity = [{dismissible: true}];

  activities = {};
  classifications = {};

  activitiesInit: any;
  activitiesInits: any;
  classificationInit: any;
  classificationInits: any;

  modalPurpose: string = 'add';

  activityFunctionDatas: any;
	generalfunctionSelects: any[];
  sectionfunctionSelects: any[];

  customers = {};
  get selectedCustomerId(): string { return this.selectedIds[0]; }
  customerSub: Subscription;
  
  employees = {};
  get selectedEmployeeId(): string { return this.selectedIds[1]; }
  employeeSub: Subscription;
  
  prVntas = {};
  get selectedPrVntaId(): string { return this.selectedIds[2]; }
  prVntaSub: Subscription;

  quots = {};
  get selectedQuotId(): string { return this.selectedIds[3]; }
  quotSub: Subscription;

  prCmpasSub: Subscription;

  codeGivenByVal: string;
  code: string;
  setGiven(str){
    const customerId = this.selectedCustomerId;
    if(customerId){
      this.codeGivenByVal = str;
      if(str == 'Automática'){
        this.code = `${this.customers[customerId].initials}-${this.ceroes(this.customers[customerId].nextProduct,4)}`;
        this.prClientForm.get('code').patchValue(this.code);
        this.prClientForm.get('code').disable();
      }else{
        this.prClientForm.get('code').enable();
      }
    }else toast('Seleccione un cliente primero.',3000)
  }

  prClientId: string;

  constructor(
    private fb: FormBuilder,
    private service: ProductClientService,
    private prClientData: PrClientData,
    public odpData: ProductionOrderData,
    private customerService: CustomerSupplierService,
    private employeeService: EmployeeService,
    private prVntaService: ProductVntaService,
    private prCmpaService: ProductCmpaService,
    private suajeService: SuajeService,
    private unitService: UnitService,
    private quotService: QuotService,
    private quotationFunctionData: QuotationFunctionData,
    private activityService: ActivityService,
    private activityClassificationService: ActivityClassificationService,
    private activatedRoute: ActivatedRoute,
    private permissionService: PermissionService,
    private authService: AuthService,
    private afh: FirestoreService,
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
    });

    this.selects = this.prClientData.allSelects;
    this.prClientId = this.activatedRoute.snapshot.paramMap.get('id');

    this.customers = {};
    this.customerSub = this.customerService.getCustomers().subscribe(customers => {
      this.rowsRead[0] = customers.map(customer => {
        customer.id = customer.id$;
        this.customers[customer.id] = customer;
        return customer;
      })
    });
    this.employees = {};
    this.employeeSub = this.employeeService.getEmployees().subscribe(employees => {
      this.rowsRead[1] = employees.map(employee => {
        employee.id = employee.id$;
        employee.name = `${employee.name} ${employee.lastName}`;
        this.employees[employee.id] = employee;
        return employee;
      })
    });
    this.prVntas = {};
    this.prVntaSub = this.prVntaService.getPrVntas().subscribe(prVntas => {
      this.rowsRead[2] = prVntas.map(prVnta => {
        this.prVntas[prVnta.id] = prVnta;
        prVnta.class = prVnta.data.name;
        return prVnta;
      })
    });
    this.quots = {};
    this.quotSub = this.quotService.getQuots().subscribe(quots => {
      this.unfilteredQuotRows = quots.map(quot => {
        this.quots[quot.id] = quot;
				quot.name = quot.folio;
				return quot;
      });
      if(this.unfilteredQuotRows) this.updateQuotRows();
    });

    this.sections = [];
    this.activityFunctionDatas = this.quotationFunctionData.functionData;
    this.activityFunction = {};
    this.generalfunctionSelects = [];
		this.sectionfunctionSelects = [];
		quotationFunctionData.selectArray.map(data => {
			if(data.isGeneral) this.generalfunctionSelects.push(data);
			else this.sectionfunctionSelects.push(data);
		})

    this.activities = {};
    this.activitiesInits = { 'section': {data: {}}, 'general': {data: {}}, };
    let subActivity = this.activityService.getActivities().subscribe(activities => {
      subActivity.unsubscribe();
      const data = activities.reduce((acc, cur) => {
        const type = cur.activityClassObj.perSection ? 'section' : 'general';
        this.activitiesInits[type].data[`${cur.name.trim()}`] = null;
        this.activities[`${cur.name.trim()}`] = {
          ...cur,
          classification: cur.activityClassObj.name,
          ranges: cur.ranges || [],
          prices: cur.prices || [],
          quantityPricesFunction: cur.quantityPricesFunction || '',
          unique: cur.unique || {},
          actId: cur.id
        };
        this.activities[`${cur.id}`] = this.activities[`${cur.name.trim()}`];
        if(cur.appliesPrVnta) (cur.isGeneral ? [] : this.nonGeneralActivities).push({
          name: cur.name,
          classification: cur.activityClassObj.name,
          quantityPricesFunction: cur.quantityPricesFunction || '',
          dataCalc: cur.dataCalc,
          prices: cur.prices || [],
          ranges: cur.ranges || [],
          unique: cur.unique || {},
          actId: cur.id
        });
        this.nonGeneralActivities.sort(({classification: c1},{classification: c2}) => c1 > c2 ? 1 : -1).sort(({name: c1},{name: c2}) => c1 > c2 ? 1 : -1);
        return acc;
      }, {});
    });

    this.classifications = {};
    this.classificationInits = { 'section': {data: {}}, 'general': {data: {}}, };
    let classSub = this.activityClassificationService.getActivityClassifications().subscribe(tempClassifications => {
      classSub.unsubscribe();
      for (const idx in tempClassifications) {
        const type = tempClassifications[idx].perSection ? 'section' : 'general';
        this.classificationInits[type].data[`${tempClassifications[idx].name.trim()}`] = null;

        this.classifications[tempClassifications[idx].name] = { id: tempClassifications[idx].id$, isGeneral: !tempClassifications[idx].perSection };
        this.classifications[tempClassifications[idx].id$] = { name: tempClassifications[idx].name, isGeneral: !tempClassifications[idx].perSection };
      }
    });

    let unitSub = this.unitService.getUnits().subscribe(units => {
      unitSub.unsubscribe();
      this.prCmpasSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {
        const data = prCmpas.reduce((acc, cur) => {
          cur.characs = cur.characs.reduce((acc2, cur2, index) => {
            let unit = units.find(({id}) => id == cur2.unitId.id);
            let symbol = unit ? unit.symbol : '';
            return acc2 + `${index ? ', ' : ''}${cur2.name}: ${cur2.value}${symbol}`;
          }, '');
          acc[`${cur.name} - ${cur.characs}`] = null;
          this.uniqueInit.papelData[`${cur.name} - ${cur.characs}`] = {...cur};
          return acc;
        }, {});
        this.uniqueInit.papel = { 'data': data };
      });
    });
  }

  ngOnInit() {
    this.createForm();
    this.createSectionForm();
    this.createActivityForm();
    let sub = this.service.getPrClient(this.prClientId).subscribe(([prClient]) => {
      sub.unsubscribe();

      let suajeSub = this.suajeService.getSuajes().subscribe(suajes => {
        suajeSub.unsubscribe();
        this.uniqueInit.unfilteredSuajes = suajes;
        this.filterSuajes(prClient.customerId);
      });

      this.prClient = prClient;
      this.prClientForm.patchValue(prClient);
      if(prClient.packaging){
        this.prClientForm.get('wide').patchValue(prClient.packaging.wide);
        this.prClientForm.get('long').patchValue(prClient.packaging.long);
        this.prClientForm.get('height').patchValue(prClient.packaging.height);
      }

      this.selectedIds[0] = prClient.customerId;
      this.selectedIds[1] = prClient.employeeId;
      this.selectedIds[2] = prClient.prVntaId;
      this.selectedIds[3] = prClient.quotationId;

      if(this.unfilteredQuotRows) this.updateQuotRows();

      this.codeGivenByVal = prClient.codeGivenBy;
      this.setGiven(this.codeGivenByVal);
      this.sections = prClient.sections || [];
      this.generalActivities = prClient.generalActivities || [];

    });
  }

  createForm(){
    this.prClientForm = this.fb.group({
      isLineProduct: ['', Validators.required],
      isLastVersion: ['', Validators.required],
      code: ['', Validators.required],
      version: ['', Validators.required],
      barCode: '',
      designStatus: '',
      designComments: '',
      qualityStatus: '',
      qualityComments: '',
      shortDescription: ['', Validators.required],
      longDescription: ['', Validators.required],
      processOwnerComments: '',
      newVersionMotive: '',
      //new
      IDPln: '',
      agreedPrice: '',
      characteristics: '',
      agreedDate: '',
      wide: '',
      long: '',
      height: '',
      valid: '',
      flatNumber: '',
    });
  }
  createSectionForm(){
    this.sectionForm = this.fb.group({
      name: ['', Validators.required],
      width: ['', Validators.required],
      height: ['', Validators.required],
      sizeInPaper: ['', Validators.required],
      pieceInSize: ['', Validators.required],
      frontInk: ['', [Validators.required, Validators.max(8)]],
      backInk: ['', [Validators.required, Validators.max(8)]],
      sheetWidth: ['', Validators.required],
      sheetHeight: ['', Validators.required],
      numPages: ['', Validators.required],
      pieceHeight: ['', Validators.required],
      pieceLong: ['', Validators.required],
      pieceWidth: ['', Validators.required],
    });
  }
  createActivityForm() {
    this.activityForm = this.fb.group({
      name: ['', Validators.required],
			classification: ['', Validators.required],
      quantityPricesFunction: ['', Validators.required],
      prices: this.fb.array([]),
      minRange: '',
      maxRange: '',
      rangePrice: ''
    });
  }
	get qpFunction(){ return this.activityForm.get('quantityPricesFunction').value; }

  async onSubmit({ value, valid }: { value: any, valid: any }){
    let {wide, long, height, ...prClient} = value;
    prClient.packaging = {wide, long, height};

    prClient.customerId = this.selectedCustomerId;
    prClient.employeeId = this.selectedEmployeeId;
    prClient.prVntaId = this.selectedPrVntaId;
    prClient.quotationId = this.selectedQuotId;

    prClient.sections = this.sections;
    prClient.generalActivities = this.generalActivities;
    prClient.codeGivenBy = this.codeGivenByVal;
    prClient.code = prClient.code ? prClient.code : this.code;

    //code and version verification
    /* Pidieron en whats que se quitara la verificación
    console.log(prClient.customerId,prClient.code,prClient.version)
    let prClients = await this.afh.colWithIds<PrClientId>(this.service.collection);
    for(let doc of prClients) if(doc.id != this.prClientId && prClient.customerId == doc.customerId && prClient.code == doc.code && prClient.version == doc.version) return toast('Código y versión repetidos.', 3000);
    */

    this.service.updatePrClient(this.prClientId,prClient);
    this.imagesToDelete.map(imageName => { this.service.deleteFileNoUpdate(this.prClientId, imageName) });
    this.service.windowReplace('view', this.prClientId);
  }

  ceroes(digit,num){
    var str = digit + '';
    if(str.length < 4) return this.ceroes('0' + str,num);
    else return str;
  }

  msg(str: string, b: boolean){
    if(b) return toast(`No tiene permisos de estatus de ${str}.`, 3000);
  }

  ngOnDestroy(){
    this.customerSub.unsubscribe();
    this.employeeSub.unsubscribe();
    this.prVntaSub.unsubscribe();
    this.quotSub.unsubscribe();
    this.prCmpasSub.unsubscribe();
  }

  //////////////////////////////////////////////////////////////////////////SECTION
  touchSection({ value, valid }: { value: any, valid: boolean }){
    if(this.modalPurpose == 'add'){
      value.activities = this.sectionAppliesPrVnta ? [...this.nonGeneralActivities] : [];
      value.inks = { front :  [...this.inks], back: [...this.inks] };
      this.sections.push(value);
    }else{
      value.activities = this.sections[this.currentSectionTab].activities;
      value.inks = this.sections[this.currentSectionTab].inks;
      let {frontInk, backInk} = value;
      for(let i = 0; i < 8 ; i ++){
        if(i >= frontInk) value.inks.front[i] = '';
        if(i >= backInk) value.inks.back[i] = '';
      }
      this.sections[this.currentSectionTab] = value;
    }
    this.closeModalSection();
  }
  removeSection(index) {
    if(this.sections[index].fileURL) this.imagesToDelete.push(this.sections[index].fileName);
    this.sections.splice(index, 1);
  }
  changeSectionTab(index) {
    if(this.currentSectionTab == index) this.currentSectionShowing = !this.currentSectionShowing;
    else{
      this.currentSectionTab = index;
      this.currentSectionShowing = true;
    }
    console.log(this.currentSectionShowing,this.currentSectionTab);
  }
  openModalSection(action: string, index?: number) {
    this.modalPurpose = action;
    this.sectionAppliesPrVnta = false;
    this.sectionForm.reset();
    if(action == 'edit'){
      this.currentSectionShowing = true;
      this.currentSectionTab = index;
      var section = this.sections[index];
      this.sectionForm.patchValue(section);
      console.log(this.currentSectionShowing,this.currentSectionTab);
    }
    this.modalActionsSection.emit({ action: 'modal', params: ['open'] });
  }
  closeModalSection() {
    this.modalActionsSection.emit({ action: 'modal', params: ['close'] });
  }

  get inks(){ return [...Array(8)].map((u, i) => "") }
  //////////////////////////////////////////////////////////////////////////SECTION

  //////////////////////////////////////////////////////////////////////////ACTIVITY
  touchActivity({ value, valid }: { value: any, valid: boolean }) {
    var activity = value;
    activity.actId = this.currentActId;
    activity.dataCalc = this.activityDataCalc;
    if(activity.dataCalc === 0){
      activity.ranges = this.activityRanges;
      activity.prices = [];
    }else if(activity.dataCalc > 0){
      activity.prices = value.prices.map(object => object.price);
      activity.ranges = [];
    }
    if(this.unique[activity.quantityPricesFunction]) activity.unique = {...this.unique[activity.quantityPricesFunction]};
	  let {id=''} = activity.unique && this.uniqueInit.papelData[activity.unique.prCmpaDescription] || {};
	  if(id) activity.unique.prCmpaId = id;
    /* if(activity.quantityPricesFunction == 'papel') activity.unique = { prCmpaDescription: this.unique.papel.prCmpaDescription};
    if(activity.quantityPricesFunction == 'suaje') activity.unique = { suajeDescription: this.unique.suaje.suajeDescription}; */
    delete activity.minRange;
    delete activity.maxRange;
    delete activity.rangePrice;
    if(this.activityIsGeneral){
      if(this.modalPurpose == 'add') this.generalActivities.push(activity);
      else this.generalActivities[this.currentActivityEdit] = activity;
    }else{
      //console.log(this.sections); // No borrar por favor :(
      if(this.modalPurpose == 'add') this.sections[this.currentSectionTab].activities.push(activity);
      else this.sections[this.currentSectionTab].activities[this.currentActivityEdit] = activity;
    }
    this.closeModalActivity();
    
  }
  removeActivity(isGeneral: boolean, index: number) {
    let acts = isGeneral ? this.generalActivities : this.sections[this.currentSectionTab].activities;
    if(!confirm(`¿Borrar la actividad ${acts[index].name}?`)) return;
    acts.splice(index, 1);
  }

  openModalActivity(action: string, isGeneral: boolean, index?: number) {
    this.currentActId = '';
    while(this.prices.length > 0) this.prices.removeAt(0);
    this.modalPurpose = action;
    this.activityForm.reset();
    this.activityFunction = {};
    this.activityDataCalc = '';
    this.activityRanges = [];
    this.activityIsGeneral = isGeneral;
    const type = isGeneral ? 'general' : 'section';
    this.unique.papel.prCmpaDescription = '';
    this.unique.papel.prCmpaId = '';
    this.unique.papel.hilo = this.odpData.hiloOptions[0],
    this.unique.suaje.suajeDescription = '';
    this.unique.pegado.pasteType = '6';
    this.updateActivitiesInit(type);
    this.updateClassificationInit(type);
    if(action == 'edit'){
      this.currentActivityEdit = index;
      var activity = isGeneral ? this.generalActivities[index] : this.sections[this.currentSectionTab].activities[index];
      this.currentActId = activity.actId || '';
      this.activityDataCalc = activity.dataCalc;
      this.activityForm.get('name').patchValue(activity.name);
      this.activityForm.get('classification').patchValue(activity.classification);
      this.activityForm.get('quantityPricesFunction').patchValue(activity.quantityPricesFunction);
      this.activityFunction = this.activityFunctionDatas[activity.quantityPricesFunction];
      if(activity.quantityPricesFunction == 'papel') this.unique.papel.prCmpaDescription = activity.unique && activity.unique.prCmpaDescription || '';
      if(activity.quantityPricesFunction == 'papel') this.unique.papel.prCmpaId = activity.unique && activity.unique.prCmpaId || '';
      if(activity.quantityPricesFunction == 'papel') this.unique.papel.hilo = activity.unique && activity.unique.hilo || this.odpData.hiloOptions[0];
      if(activity.quantityPricesFunction == 'suaje') this.unique.suaje.suajeDescription = activity.unique && activity.unique.suajeDescription || '';
      if(activity.quantityPricesFunction == 'pegado') this.unique.pegado.pasteType = activity.unique && activity.unique.pasteType || '6';
      this.activityRanges = activity.ranges;
      if(activity.dataCalc > 0){
        this.labels = this.activityFunction.labels;
        activity.prices.map(number => {
          this.prices.push(this.fb.group({price: number}));
        });
      }
    }else{
      if(this.activityIsGeneral) var array = this.generalfunctionSelects;
      else var array = this.sectionfunctionSelects;
      this.activityForm.get('quantityPricesFunction').patchValue(array[0].value);
      this.onChangeAFunction(array[0].value);
    }
    this.modalActionsActivity.emit({ action: 'modal', params: ['open'] });
  }
  closeModalActivity() {
    this.modalActionsActivity.emit({ action: 'modal', params: ['close'] });
  }

  updateActivitiesInit(type){
    this.activitiesInit = this.activitiesInits[type];
  }
  updateClassificationInit(type){
    this.classificationInit = this.classificationInits[type];
  }
  
  currentActId: string = '';
  onChangeAName(name){
    if(this.activities[name]){
      var activity = this.activities[name];
      this.currentActId = activity.actId;
      if(activity.quantityPricesFunction == 'papel') this.unique.papel.prCmpaDescription = activity.unique && activity.unique.prCmpaDescription || '';
      if(activity.quantityPricesFunction == 'papel') this.unique.papel.prCmpaId = activity.unique && activity.unique.prCmpaId || '';
      this.activityDataCalc = activity.dataCalc;
      this.activityForm.get('classification').patchValue(activity.classification);
      this.activityForm.get('quantityPricesFunction').patchValue(activity.quantityPricesFunction);
      this.activityFunction = this.activityFunctionDatas[activity.quantityPricesFunction];
      this.activityRanges = activity.ranges;
      while(this.prices.length > 0) this.prices.removeAt(0);
      if(activity.dataCalc > 0){
        this.labels = this.activityFunction.labels;
        activity.prices.map(number => {
          this.prices.push(this.fb.group({price: number}));
        });
      }
    }
  }
  onChangeAFunction(functionName){
    this.activityFunction = this.activityFunctionDatas[functionName];
    this.activityDataCalc = this.activityFunction.dataCalc;
    while(this.prices.length > 0) this.prices.removeAt(0); //reset prices por pushing
		this.labels = this.activityFunction.labels;
		if(this.activityFunction.dataCalc > 0 ) for(var i = 0; i < this.activityFunction.dataCalc; i++) this.prices.push(this.priceForm());
  }

  touchActivityRange(){
    const min = Math.abs(+this.activityForm.get('minRange').value);
    const max = Math.abs(+this.activityForm.get('maxRange').value);
    const price = Math.abs(+this.activityForm.get('rangePrice').value);
    if(!isNaN(min) || !isNaN(max) || !isNaN(price)){
      this.activityRanges.push({
        min: min,
        max: max,
        price: price
      });
      this.activityForm.get('minRange').reset();
      this.activityForm.get('maxRange').reset();
      this.activityForm.get('rangePrice').reset();
    }
  }
  removeActivityRange(index){
    this.activityRanges.splice(index,1);
  }
  get prices(): FormArray {
		return this.activityForm.get('prices') as FormArray;
	}
	priceForm(){
		return this.fb.group({
			price: ['', Validators.required]
		});
  }

  filterSuajes(customerId?){
    const data = this.uniqueInit.unfilteredSuajes.filter(({customerRef: {id} }) => !customerId || id == customerId).sort((a,b) => `${a.code} - ${a.size}` > `${b.code} - ${b.size}` ? 1 : -1).reduce((acc, cur) => {
      cur.size = `La ${cur.long} x An ${cur.wide} x Al ${cur.height}`;
      acc[`${cur.code} - ${cur.size}`] = null;
      return acc;
    }, {});
    this.uniqueInit.suaje = { 'data': data };
  }
  suajeClick(){
    if(!this.permission.prClientPreProduction) return toast(`No tiene permiso de ${SpecialPermissions.prClientPreProduction}.`, 2000);
  }
  //////////////////////////////////////////////////////////////////////////ACTIVITY

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    if(this.currentReadIndex == 3 && !confirm('Esto borrará las secciones y actividades. ¿Desea continuar?')) return;
    this.closeModalRead();
    this.selectedIds[this.currentReadIndex] = data.row.id;
    if(this.currentReadIndex == 0){
      this.setGiven(this.codeGivenByVal)
      this.updateQuotRows();
      this.filterSuajes(data.row.id);
      this.selectedIds[3] = '';
    }else if(this.currentReadIndex == 2){
      console.log(data.row);
      if(!confirm("¿Desea importar secciones y actividades?")) return;
      this.sections = data.row.sections.map(section => ({
        inks: { front :  [...this.inks], back: [...this.inks] },
        ...section
      }) );
      this.generalActivities = data.row.generalActivities;
      this.generalActivities.sort(({classification: c1},{classification: c2}) => c1 > c2 ? 1 : -1).sort(({name: c1},{name: c2}) => c1 > c2 ? 1 : -1);
    }else if(this.currentReadIndex == 3){
      let quot = this.quots[data.row.id]
      this.prClientForm.get('shortDescription').patchValue(quot.shortDescription);
      this.prClientForm.get('longDescription').patchValue(quot.longDescription);
      this.sections.forEach((s, i) => this.removeSection(i));
      this.sections = quot.sections.map(section => ({
        inks: { front :  [...this.inks], back: [...this.inks] },
        ...section
      }) );
      this.generalActivities = quot.generalActivities;
      this.generalActivities.sort(({classification: c1},{classification: c2}) => c1 > c2 ? 1 : -1).sort(({name: c1},{name: c2}) => c1 > c2 ? 1 : -1);
    }
  }
  unselectRead(index: number){
    this.closeModalRead();
    this.selectedIds[index] = '';
    if(this.currentReadIndex == 0){
      this.codeGivenByVal = 'Manual';
      this.prClientForm.get('code').reset();
      this.selectedIds[3] = '';
    }
  }

  get readValid(){ return this.selectedIds[0] && this.selectedIds[1] && this.selectedIds[2] };
  currentReadIndex: number;
  rowsRead = [[], [], [], []];
  columnsRead = [
    [//customer
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [//employee
      { title: 'Nombre', name: 'name' },
      { title: 'Folio', name: 'internalKey', sort: 'asc' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [//prVnta
      {title: 'Nombre', name: 'name',sort: 'asc'},
      {title: 'Descripción', name: 'description'},
      {title: 'Clasificación' , name: 'class'},
      {title: 'Código', name: 'code'},
    ],
    [//quot
      { title: 'Folio', name: 'name', sort: 'asc' },
      { title: 'Fecha', name: 'date' },
      { title: 'Estado', name: 'status' }
    ]
  ]

  unfilteredQuotRows: any[];
  updateQuotRows(){
    this.rowsRead[3] = this.unfilteredQuotRows.filter(quot => quot.customerObj.id == this.selectedCustomerId);
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA


  money = Utils.money;

}
